module.exports = __webpack_public_path__ + "static/media/zoomin.0c168ecb.svg";